import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@wetransfer/transfer/hooks';
import {
  closeTransferWindowDrawer,
  selectIsTransferWindowDrawerOpen,
} from '@wetransfer/transfer/store/transferWindowDrawer';

import { useClickOutside } from './hooks/useClickOutside';
import styles from './TransferWindowDrawer.module.scss';
import { TransferWindowDrawerProps } from './types';

export function TransferWindowDrawer({ children }: TransferWindowDrawerProps) {
  const isDrawerOpen = useSelector(selectIsTransferWindowDrawerOpen);
  const dispatch = useAppDispatch();

  const closeDrawer = useCallback(() => {
    dispatch(closeTransferWindowDrawer());
  }, [dispatch]);

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(
    ref,
    useCallback(() => {
      if (isDrawerOpen) {
        closeDrawer();
      }
    }, [isDrawerOpen, closeDrawer])
  );

  return (
    <div
      className={classNames(styles.wrapper, isDrawerOpen && styles.open)}
      ref={ref}
      aria-hidden={isDrawerOpen ? 'false' : 'true'}
    >
      {children}
    </div>
  );
}
